import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import * as _ from 'lodash';
import { UserRoleService } from '../../services/user-role.service';
@Component({
  selector: 'app-unit6-observation-criteria',
  templateUrl: './unit6-observation-criteria.component.html',
  styleUrls: ['./unit6-observation-criteria.component.scss']
})
export class Unit6ObservationCriteriaComponent implements OnInit {

  observationCriteriaForm
  @Input('learner') learnerData;
  @Input('singleJob') jobData;
  @Input('assesment') assessmentPlanEdit;
  learnerId: any;
  jobId: any;
  assessmentEdit: any;
  loading = false
  isEdit: boolean = false
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public _userRoleService : UserRoleService
  ) { }

  ngOnInit() {
    if (!this.isEdit)
      this.createForm()
  }



  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue
    }

    if (changes.jobData && changes.jobData.currentValue) {
      this.jobId = changes.jobData.currentValue[0]
      this.getUserRole();
    }
    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
      this.assessmentEdit = changes.assessmentPlanEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);

      if (this.assessmentPlanEdit && this.assessmentPlanEdit.observationCriteriaForm) {
        this.isEdit = true;
        this.createForm(this.assessmentEdit)
      } else {
        this.createForm()
      }

    }
  }
  getUserRole(){
    let getRole = this._userRoleService.getUserRole(this.jobId.instructors,'job');

    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

  }




  // FORM CONTROL


  createForm(details?) {
    this.observationCriteriaForm = new FormGroup({
      date: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.date : ''),
      session: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.session : ''),
      session1: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.session1 : ''),
      session2: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.session2 : ''),
      session3: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.session3 : ''),
      session4: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.session4 : ''),
      warmUp: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp : ''),
      warmUp1: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp1 : ''),
      warmUp2: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp2 : ''),
      warmUp3: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp3 : ''),
      warmUp4: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp4 : ''),
      warmUp5: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp5 : ''),
      warmUp6: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp6 : ''),
      warmUp7: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp7 : ''),
      warmUp8: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp8 : ''),
      warmUp9: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp9 : ''),
      warmUp10: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp10 : ''),
      warmUp11: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp11 : ''),
      warmUp12: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp12 : ''),
      warmUp13: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp13 : ''),
      warmUp14: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp14 : ''),
      warmUp15: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp15 : ''),
      warmUp16: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.warmUp16 : ''),
      section: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section : ''),
      section1: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section1 : ''),
      section2: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section2 : ''),
      section3: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section3 : ''),
      section4: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section4 : ''),
      section5: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section5 : ''),
      section6: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section6 : ''),
      section7: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section7 : ''),
      section8: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section8 : ''),
      section9: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section9 : ''),
      section10: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section10 : ''),
      section11: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section11 : ''),
      section12: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section12 : ''),
      section13: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section13 : ''),
      section14: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section14 : ''),
      section15: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section15 : ''),
      section16: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.section16 : ''),
      coolDown: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown : ''),
      coolDown1: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown1 : ''),
      coolDown2: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown2 : ''),
      coolDown3: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown3 : ''),
      coolDown4: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown4 : ''),
      coolDown5: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown5 : ''),
      coolDown6: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown6 : ''),
      coolDown7: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown7 : ''),
      coolDown8: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown8 : ''),
      coolDown9: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown9 : ''),
      coolDown10: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown10 : ''),
      coolDown11: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown11 : ''),
      coolDown12: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown12 : ''),
      coolDown13: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown13 : ''),
      coolDown14: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown14 : ''),
      coolDown15: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown15 : ''),
      coolDown16: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.coolDown16 : ''),
      competent: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.competent : ''),
      nonCompetent: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.nonCompetent : ''),
      feedBack: new FormControl((details && details.observationCriteriaForm) ? details.observationCriteriaForm.feedBack : ''),

    })
  }



  // UTILITY

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'observationCriteriaForm')
      this.observationCriteriaForm.get(formControl).setValue(value);
  }


  // API CALL

  submitForm() {
    console.log("observation form value", this.observationCriteriaForm.value);
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId._id,
      version: true,
      details: {
        observationCriteriaForm: this.observationCriteriaForm.value,
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })
  }

}
